import { HOST } from "../constants/HostConstants";
import { clearAllCache } from "../services/apiService";

export const logoutUser = async ({ setUser }) => {
  fetch(`${HOST}/api/user/userLogout`, {
    method: "GET",
    credentials: "include",
    headers: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json",
    },
  })
    .then((res) => res.json())
    .then((data) => {
      // Clear all cached data on logout to prevent stale data
      clearAllCache();
      setUser(null);
    });
};
